import * as React from 'react';
import { Link } from 'react-router-dom';
import ReactEcharts from 'echarts-for-react';
import { IPens, IAxisSetting, IConfig } from '.';
import { EChartOption } from 'echarts';
import { debug } from 'console';
import EChartsReact from 'echarts-for-react';
import { param } from 'jquery';

interface IGraphs {
    data: any;
    pens: IPens[];
    echarts_react: any;
    notMerge: boolean;
    calbacUpdateRow: any;
    id: string;
    config: IConfig;
    newSeriesPoints: any[];
}

export type TrendHandle = {
    DefaultCursor: () => void;
    ActiveZoomSelect: () => void;
    ZoomReset: () => void;
    HorizontSelect: () => void;
    KeepSelect: () => void;
    ClearSelect: () => void;
    SaveAsData: () => void;
};

const TrendsGraphs = React.forwardRef<TrendHandle, IGraphs>((props, forwardedRef) => {
    const dataline = {
        name: '',
        type: 'line',
        step: false,
        symbol: 'none',
        showSymbol: true,
        hoverAnimation: false,
        symbolSize: 3,
        lineStyle: { color: '#000', width: 1 },
        large: true,
        data: {}
    };

    const option_def: EChartOption = {
        grid: {
            right: 15,
            top: 30,
            bottom: 25
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.45)',
            position: function (pos: any, params: any, el: any, elRect: any, size: any) {
                var obj: any = { top: 10 };
                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                return obj;
            },
            formatter: function (params: any) {
                const usedSeriesNames: { [key: string]: boolean } = {};

                params.sort(function (a: any, b: any) {
                    return parseInt(b.value) - parseInt(a.value);
                });

                let output = '<b></b><br/>';

                if ((props.config.settings.chart.xAxis as IAxisSetting)?.type == 'time') {
                    let d = new Date(params[0].value[0]);
                    var datestring =
                        d.getDate() +
                        '/' +
                        (d.getMonth() + 1) +
                        '/' +
                        d.getFullYear() +
                        ' ' +
                        d.getHours() +
                        ':' +
                        d.getMinutes() +
                        ':' +
                        d.getSeconds();
                    output = '<b>' + datestring + '</b><br/>';
                } else {
                    output = '<b>' + params[0].value[0] + '</b><br/>';
                }

                for (let ipar = 0; ipar < params.length; ipar++) {
                    // Проверяем, является ли значение NaN, чтобы избежать ошибок при его преобразовании в число
                    if (!isNaN(params[ipar].value[1]) && !usedSeriesNames.hasOwnProperty(params[ipar].seriesName)) {
                        output +=
                            params[ipar].marker + params[ipar].seriesName + ': ' + params[ipar].value[1]?.toFixed(3);
                        usedSeriesNames[params[ipar].seriesName] = true;

                        if (ipar != params.length - 1) {
                            output += '<br/>';
                        }
                    }
                }
                return output;
            },
            axisPointer: {
                animation: false
            }
        },
        toolbox: {
            feature: {
                dataZoom: {
                    title: {
                        zoom: 'Масштабирование области',
                        back: 'Предыдущее масштабирование области'
                    },
                    icon: null
                },
                restore: { show: true, title: 'Сброс', icon: null },
                brush: {
                    icon: {
                        clear: null,
                        rect: null,
                        polygon: null,
                        lineX: null,
                        lineY: null,
                        keep: null
                    }
                },
                dataView: {
                    icon: null,
                    readOnly: true,
                    lang: ['Загрузка данных', 'Назад', 'Обновить'],
                    title: 'Скачать',
                    optionToContent: function (opt: any) {
                        var series = opt.series;

                        let ids = '';

                        for (var i = 0, l = series.length; i < l; i++) {
                            ids = ids + "'" + series[i].name + "'" + ',';
                        }

                        let table =
                            `<div style="display: flex;flex-direction: column;align-items: baseline;font-size: 1.4em;">
                                        <label id="deltaTimeLabel" style="margin: 5px;">Диапазон: <input type="datetime-local" id="minTime" value="` +
                            (props.config.settings.chart.xAxis as IAxisSetting)?.min +
                            `" step="2"> - <input type="datetime-local" id="maxTime" value="` +
                            (props.config.settings.chart.xAxis as IAxisSetting)?.max +
                            `" step="2"></label>
                                        <label style="margin: 5px;">Тип разделителя: <input type="text" Value=";" id="downloadDelimiter" ></label>
                                        <label style="margin: 5px;">Функция обработки данных: 
                                        <select id="downloadType" onchange="
                                                                                    if (this.value == 1) document.getElementById('downloadTimeLabel').style='display:block';
                                                                                    else document.getElementById('downloadTimeLabel').style='display:none';">
                                                                                  <option value="1">Интерполяция</option>
                                                                                  <option value="2">Cырые значения</option>
                                                                                </select>
                                        </label>
                                        <label id="downloadTimeLabel" style="margin: 5px;">Интервал времени: <input type="time" value="00:00:01" id="downloadTime" step="2"></label>
                                        <div style="margin: 5px;" style="display: flex;flex-direction: row;">
                                            <div style="float: right; margin-right: 20px; border: none; cursor: pointer; padding: 2px 5px; font-size: 12px; border-radius: 3px; background-color: rgb(53, 159, 49); color: rgb(255, 255, 255);" 
                                                onclick="let ids = [` +
                            ids +
                            `];
                                                window.HDAServer.ExportCSV(ids, document.getElementById('minTime').value, document.getElementById('maxTime').value,document.getElementById('downloadDelimiter').value,document.getElementById('downloadType').value,document.getElementById('downloadTime').value);">Загрузить</div>
                                        </div>
                                        </div>`;
                        return table;
                    }
                }
            }
        },
        brush: {
            toolbox: [],
            xAxisIndex: 'all',
            brushLink: 'all',
            outOfBrush: {
                colorAlpha: 0.2
            },
            throttleType: 'debounce'
        },
        xAxis: {
            type: 'time',
            silent: false,
            splitLine: {
                show: false
            },
            splitArea: {
                show: false
            }
        }
    };
    const [option, setOption] = React.useState<EChartOption>({});

    React.useImperativeHandle(forwardedRef, () => ({
        ActiveZoomSelect() {
            ActiveZoomSelect();
        },
        ZoomReset() {
            ZoomReset();
        },
        HorizontSelect() {
            HorizontSelect();
        },
        KeepSelect() {
            KeepSelect();
        },
        ClearSelect() {
            ClearSelect();
        },
        SaveAsData() {
            SaveAsData();
        },
        DefaultCursor() {
            DefaultCursor();
        }
    }));

    React.useEffect(() => {
        let getOption = () => {
            let newOption: EChartOption = option.grid ? option : option_def;

            let seriesall: any[] = [];
            let yAxisArr: any = [];
            let dataZoomArr: EChartOption.DataZoom[] = [
                {
                    type: 'inside',
                    orient: 'horizontal',
                    filterMode: 'none'
                }
            ];

            let colors: string[] = [];

            let namesLegend = [];

            let formatterData = function (a: any) {
                return a.toLocaleString();
            };

            for (let i = 0; i < props.pens.length; i++) {
                if (props.pens[i].name != '' && props.pens[i].enable) {
                    let seriestemp = JSON.parse(JSON.stringify(dataline));

                    let name = props.pens[i].name;
                    if (name.indexOf('.MODE') != -1 || name.indexOf('.STATE') != -1) {
                    }

                    if (props.data[name] && props.pens[i].enable) {
                        seriestemp.data = props.data[name];
                    } else {
                        seriestemp.data = [];
                    }

                    if (props.pens[i].markArea !== undefined && props.pens[i].enable) {
                        seriestemp.markArea = props.pens[i].markArea;
                    }

                    seriestemp.name = name;
                    namesLegend.push(name);

                    seriestemp.lineStyle.color = props.pens[i].color;

                    colors.push(props.pens[i].color);

                    if (props.pens[i].selected) {
                        seriestemp.lineStyle.width = 3;
                        seriestemp.symbolSize = 4;
                        // seriestemp.markLine.lineStyle.width = 3;
                    }

                    seriestemp.yAxisIndex =
                        props.pens[i].yAxisIndex != null ? props.pens[i].yAxisIndex : yAxisArr.length;

                    switch (props.pens[i].typeLine) {
                        case 'line': {
                            seriestemp.type = 'line';

                            break;
                        }
                        case 'linePoint': {
                            seriestemp.type = 'line';
                            seriestemp.symbol = 'circle';
                            seriestemp.symbolSize = props.pens[i].selected ? 12 : 10;
                            seriestemp.itemStyle = { color: props.pens[i].color };
                            break;
                        }
                        case 'point': {
                            seriestemp.type = 'scatter';
                            seriestemp.symbolSize = props.pens[i].selected ? 12 : 10;
                            seriestemp.symbol = 'circle';
                            seriestemp.lineStyle.opacity = 0;
                            seriestemp.itemStyle = { color: props.pens[i].color };
                            break;
                        }
                        case 'step': {
                            seriestemp.type = 'line';
                            seriestemp.step = 'end';
                            break;
                        }
                        case 'areadiscrete': {
                            seriestemp.type = 'line';
                            seriestemp.step = 'end';
                            seriestemp.symbol = 'none';
                            seriestemp.lineStyle.opacity = 0;
                            seriestemp.areaStyle = {
                                color: props.pens[i].color
                            };
                            break;
                        }
                        case 'radar': {
                            seriestemp.type = 'radar';
                            break;
                        }
                    }

                    seriesall.push(seriestemp);

                    if (props.pens[i].typeLine != 'radar' && seriestemp.yAxisIndex == yAxisArr.length) {
                        let formatterY = formatterData;
                        let yAxis = {
                            name: props.pens[i].eudesc,
                            type: 'value',
                            min: Number(props.pens[i].min),
                            max: Number(props.pens[i].max),
                            axisLabel: {
                                formatter: formatterY
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: props.pens[i].color
                                }
                            },
                            show: true, //props.pens[i].active,
                            position: 'left',
                            offset: 60 * yAxisArr.length
                        };

                        yAxisArr.push(yAxis);
                    } else {
                        yAxisArr[seriestemp.yAxisIndex].min = Math.min(
                            yAxisArr[seriestemp.yAxisIndex].min,
                            Number(props.pens[i].min)
                        );
                        yAxisArr[seriestemp.yAxisIndex].max = Math.max(
                            yAxisArr[seriestemp.yAxisIndex].max,
                            Number(props.pens[i].max)
                        );
                    }
                }
            }

            let yAxisNumArr: number[] = [];

            for (let i = 0; i < seriesall.length; i++) {
                yAxisNumArr.push(i);
            }

            if (yAxisArr.length == 0) {
                yAxisArr = { type: 'value' };
            }

            ///
            let hasSlider = true;
            if (yAxisNumArr.length != 0) {
                if (hasSlider) {
                    /*
                    let tempZoom:any = [{
                        type: 'slider',
                        xAxisIndex: [0],
                        filterMode: 'none',
                        brushSelect: true,                    
                        showDataShadow: false,
                        height: 10,
                        showDetail: false,
                        bottom: 10,
                        zoomLock: true,
                        handleSize: "10%",
                        moveHandleSize: 12
    
                    },
                        {
                            type: 'slider',
                            yAxisIndex: yAxisNumArr,
                            filterMode: 'none',
                            showDetail: false,
                            brushSelect: true,
                            width: 10,
                            right: 15,
                            top: 30,
                            bottom: 20,
                            showDataShadow: false,
                            zoomLock: true,
                            handleSize: "10%",
                            moveHandleSize: 12
    
                        }]
    
                    dataZoomArr = dataZoomArr.concat(tempZoom);*/
                }
            }

            let typeX =
                (props.config.settings.chart.xAxis as IAxisSetting) != undefined
                    ? ((props.config.settings.chart.xAxis as IAxisSetting).type as any)
                    : 'time';

            let formatterX = undefined;
            if (typeX != 'time') {
                formatterX = formatterData;
            }

            if ((props.config.settings.chart.xAxis as IAxisSetting)?.name) {
                if (newOption.grid) {
                    let name = (props.config.settings.chart.xAxis as IAxisSetting)?.name;
                    let nameLength = name?.length;
                    let rightValue = 25;

                    if (nameLength) {
                        rightValue += nameLength * 6;
                    }

                    newOption.grid = {
                        right: rightValue,
                        top: 30,
                        bottom: 25
                    };
                }
            }

            newOption = {
                ...newOption,
                color: colors,
                grid: {
                    ...newOption.grid,
                    left: yAxisArr.length * 60
                },
                radar: props.config.settings.chart.radar,
                xAxis: {
                    ...newOption.xAxis,
                    axisLabel: {
                        formatter: formatterX
                    },
                    name: (props.config.settings.chart.xAxis as IAxisSetting)?.name,
                    min: (props.config.settings.chart.xAxis as IAxisSetting)?.min,
                    max: (props.config.settings.chart.xAxis as IAxisSetting)?.max,
                    type: typeX
                },
                //legend: {
                //    data: (props.config.settings.chart.hasLegend) ? namesLegend : [],
                //    icon: 'rect',
                //    left: 10,
                //    width: '60%',
                //    formatter: ' '
                //},
                dataZoom: dataZoomArr,

                yAxis: yAxisArr,
                series: seriesall
            };

            return newOption;
        };
        setOption(getOption());

        // }, [props.data, props.pens, props.config]);
    }, [props.pens]);

    //Обновление графика
    React.useEffect(() => {
        if (chartRef) {
            const echartsInstance = chartRef.getEchartsInstance();
            let currentOptions = echartsInstance.getOption();

            for (let i = 0; i < props.pens.length; i++) {
                if (props.pens[i].name != '' && props.pens[i].enable) {
                    if (currentOptions && currentOptions.series && currentOptions.series?.length != 0) {
                        if (Array.isArray(currentOptions.xAxis)) {
                            currentOptions.xAxis[0].max = (props.config.settings.chart.xAxis as IAxisSetting)?.max;
                        }

                        for (let key in props.newSeriesPoints) {
                            const newPoint = props.newSeriesPoints[key][0];
                            currentOptions.series[key].data?.push(newPoint);
                        }
                        echartsInstance.setOption(currentOptions);
                    }
                }
            }
        }
    }, [props.data, props.config]);

    let chartRef: EChartsReact | undefined = undefined;
    const refDiv = React.useRef<HTMLDivElement>(null);

    const contSize = {
        width: 0,
        height: 0
    };

    const [elemSize, setElemSize] = React.useState({
        width: 0,
        height: 0
    });

    const DefaultCursor = () => {
        let trendInst = chartRef?.getEchartsInstance();
        if (trendInst) {
            trendInst.dispatchAction({
                type: 'takeGlobalCursor',
                key: 'dataZoomSelect',
                dataZoomSelectActive: false
            });
        }
    };

    const ActiveZoomSelect = () => {
        let trendInst = chartRef?.getEchartsInstance();
        if (trendInst) {
            trendInst.dispatchAction({
                type: 'takeGlobalCursor',
                key: 'dataZoomSelect',
                dataZoomSelectActive: true
            });
        }
    };

    const SaveAsData = () => {
        let trendInst = chartRef?.getEchartsInstance();
        if (trendInst) {
            trendInst.dispatchAction({
                type: 'showDataView'
            });
        }
    };

    const ClearSelect = () => {
        let trendInst = chartRef?.getEchartsInstance();
        if (trendInst) {
            trendInst.dispatchAction({
                type: 'brush',
                command: 'clear',
                areas: []
            });
        }
    };

    const KeepSelect = () => {
        let trendInst = chartRef?.getEchartsInstance();
        if (trendInst) {
            console.log('keep');
            trendInst.dispatchAction({
                type: 'takeGlobalCursor',
                key: 'brush',
                brushOption: {
                    brushType: 'lineX',
                    brushMode: 'multiple'
                }
            });
        }
    };

    const HorizontSelect = () => {
        let trendInst = chartRef?.getEchartsInstance();
        if (trendInst) {
            trendInst.dispatchAction({
                type: 'takeGlobalCursor',
                key: 'brush',
                brushOption: {
                    brushType: 'lineX'
                }
            });
        }
    };

    const ZoomReset = () => {
        let trendInst = chartRef?.getEchartsInstance();
        if (trendInst) {
            trendInst.dispatchAction({
                type: 'restore'
            });
        }
    };
    React.useEffect(() => {
        function handleResize() {
            if (refDiv) {
                if (refDiv.current) {
                    let height = refDiv.current.clientHeight; //ref.current.getClientRects()[0].height;//ref.current.clientHeight
                    let width = refDiv.current.clientWidth; ///ref.current.getClientRects()[0].width;

                    if (elemSize.height != height || elemSize.width != width) {
                        let ss = chartRef?.getEchartsInstance();
                        ss?.resize();
                        setElemSize({ height: height, width: width });
                    }
                }
            }
        }

        handleResize();
    });

    React.useEffect(() => {
        let ss = chartRef?.getEchartsInstance();
        ss?.on('brushSelected', function (params: any) {
            eventsChart.brushSelected(params);
        });
        return () => {};
    }, [chartRef]);

    const eventsChart = {
        brushSelected: (params: any) => {
            let areas = params.batch[0]?.areas;
            let trend = window.Trends.TrendsBase[props.id];
            if (areas && trend) {
                if (areas.length == 0) {
                    for (let i = 0; i < trend.brush.areas.length; ) {
                        trend.brush.areas.splice(i, 1);
                    }
                } else {
                    for (let i = 0; i < areas.length; i++) {
                        let coordRanges = areas[i]?.coordRange;
                        trend.brush.areas[i] = { coordRange: [] };
                        for (let j = 0; j < coordRanges.length; j++) {
                            let startT = coordRanges[0];
                            let endT = coordRanges[1];
                            trend.brush.areas[i].coordRange.push([startT, endT]);
                        }
                    }
                }

                trend.dispatchAction({
                    type: 'brushSelected',
                    data: trend.brush
                });
            }
        }
    };

    return (
        <div ref={refDiv} style={{ display: 'flex', height: '100%', width: '100%' }}>
            <ReactEcharts
                notMerge={props.notMerge}
                lazyUpdate={true}
                option={option}
                style={{ height: '100%', width: '100%' }}
                ref={(e: any) => {
                    chartRef = e;
                }}
                opts={{ locale: '' }}
            />
        </div>
    );
});

export default TrendsGraphs;
